import { FC, RefObject } from "react";
import { NodesMapItemDTO } from "../../../../../../datasources/api-client/data-contracts";
import { groupMarkerIcon } from "../../../utils";
import { Marker } from "react-leaflet";

interface Props {
    nodeGroup: NodesMapItemDTO;
    markers: RefObject<Record<number, L.Marker>>;
    index: number;
    color: string;
    totalNodeAmount: number;
    onMarkerClick: (lat: number, lng: number) => void;
}

export const NodeGroupMarker: FC<Props> = ({nodeGroup, index, color, markers, totalNodeAmount, onMarkerClick}) => {
    return (
        <Marker
            icon={groupMarkerIcon(nodeGroup.nodeCount, color, totalNodeAmount)}
            position={[nodeGroup.lat, nodeGroup.lng]}
            ref={(ref) => {
                if (ref) markers.current[index] = ref as unknown as L.Marker;
            }}
            eventHandlers={{
                click: () => {
                    onMarkerClick(nodeGroup.lat, nodeGroup.lng);
                }
            }}
        />
    )
}